import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ShoppingCartIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange, productPath } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from '../shop/Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Populair',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau-tip'
};
export function LivingProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  const to = productPath(product);
  return <article className="flex h-full flex-col overflow-hidden rounded-xl border border-line bg-white" data-id="element-387" data-mp="2n6lr7qkjixse">
      <Link to={to} className="group relative block overflow-hidden bg-stone" data-id="element-388" data-mp="ph2jv0xh1dsa">
        <img src={product.image} alt={`${product.name} – ${product.subtitle}`} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-389" data-mp="lez4i17olp1q" />
        {badge && <span className="absolute left-3 top-3 rounded-md bg-majorelle px-2 py-1 text-xs font-semibold text-white" data-id="element-390" data-mp="1hoxrthsvnwb6">{badgeLabel[badge]}</span>}
      </Link>
      <div className="flex flex-1 flex-col p-4" data-id="element-391" data-mp="17tmacrq34azq">
        <h3 className="font-semibold leading-snug text-ink" data-id="element-392" data-mp="1vifal0dqp505">
          <Link to={to} className="transition-colors duration-150 hover:text-majorelle" data-id="element-393" data-mp="1viyrqevkfpd4">{product.name}</Link>
        </h3>
        <p className="mt-0.5 text-sm text-muted" data-id="element-394" data-mp="20jmg0ssets3n">{product.subtitle}</p>
        <div className="mt-2" data-id="element-395" data-mp="1mpbxit70au61">
          <Stars rating={product.rating} reviews={product.reviews} data-id="element-396" data-mp="1moaoeu9jwhqy" />
        </div>
        <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-olive" data-id="element-397" data-mp="1qpvyk7upahxg">
          <CheckIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-398" data-mp="2efq9gjvglwf2" /> Op voorraad
        </p>
        <div className="mt-auto pt-4" data-id="element-399" data-mp="2j9koha04dn7t">
          <p className="flex flex-wrap items-baseline gap-x-2" data-id="element-400" data-mp="2t3zyfwx652cg">
            {hasRange(product) && <span className="text-sm text-muted" data-id="element-401" data-mp="2t1nkrvyg1e57">vanaf</span>}
            <span className="text-xl font-bold tabular-nums text-ink" data-id="element-402" data-mp="2p3pt8mh7afyn">{formatPrice(fromPrice(product))}</span>
            {first.compareAt && <span className="text-sm text-muted line-through" data-id="element-403" data-mp="2k5ej0amzu3fw">{formatPrice(first.compareAt)}</span>}
          </p>
          <button type="button" onClick={() => add(product.slug, first.id)} className="mt-3 flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-terracotta text-sm font-semibold text-white transition-colors duration-150 hover:bg-terracotta-dark" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-404" data-mp="2a546ks8s901s">
            <ShoppingCartIcon className="hidden h-4 w-4 sm:block" aria-hidden="true" data-id="element-405" data-mp="1wbwg53wfualo" />
            In winkelwagen
          </button>
        </div>
      </div>
    </article>;
}